import { Link, useLocation } from 'react-router-dom';

/**
 * Anything the route table doesn't own.
 *
 * This used to be `<Navigate to="/" replace />`, which was actively harmful: an unmatched path was
 * silently rewritten to `/` and the landing page rendered as if nothing had gone wrong. Two things
 * made that worse than a plain 404 —
 *
 *   • `/` is not the SPA in a deployed env. The edge function 302s it to `/docs` (the Mintlify
 *     proxy), so the URL we put in the address bar rendered the landing page but loaded the docs
 *     site on reload.
 *   • It swallowed the evidence. A path the edge *should* have routed elsewhere (`/docs`, `/api/*`)
 *     but that reached the SPA instead looked exactly like a signed-out user being dropped on the
 *     home page — no error, no sign-in, and nothing in the URL to say which path had missed.
 *
 * So the path stays in the address bar and is named on screen.
 */
export default function NotFoundRoute() {
  const { pathname } = useLocation();

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 14,
        padding: 24,
        textAlign: 'center',
      }}
    >
      <h1 style={{ margin: 0, fontSize: 22, letterSpacing: '-0.01em' }}>We couldn&apos;t find that page</h1>
      <p style={{ margin: 0, fontSize: 15, color: 'var(--text-secondary)', maxWidth: 440 }}>
        Nothing in the portal is served at <code style={{ fontSize: 14 }}>{pathname}</code>.
      </p>
      <div style={{ display: 'flex', alignItems: 'center', gap: 18, marginTop: 6, fontSize: 14 }}>
        <Link to="/signin" style={{ color: 'var(--accent-text)', fontWeight: 600 }}>
          Sign in
        </Link>
        <a href="/docs" style={{ color: 'var(--accent-text)', fontWeight: 600 }}>
          API reference
        </a>
      </div>
    </div>
  );
}
